import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo201",
  "use": "icon-icon-todo201-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo201\"><path d=\"M844.89 85.33H179.11L0 436.6l512 502.07 512-502.07L844.89 85.33zM106.34 419.67l126.77-248.64h557.77l126.77 248.64L512 817.46 106.34 419.67z\" /><path d=\"M512 603.21L324.41 419.26l-61.8 60.6L512 724.42l249.39-244.56-61.8-60.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo201.svg
// module id = ye2B
// module chunks = 3